/**
 * Security and authentication models
 * Migrated from ExtJS SecurityRole model and otbSecurity plugin
 */

export interface User {
  id: number;
  username: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  roles: SecurityRole[];
  isActive: boolean;
}

export interface SecurityRole {
  id: number;
  name: string;
  code: SecurityRoleCode;
  description?: string;
  permissions: string[];
}

export enum SecurityRoleCode {
  ADMIN = 'ADMIN',
  ORGANIZER = 'ORGANIZER',
  REFEREE = 'REFEREE',
  SCORER = 'SCORER',
  ANNOUNCER = 'ANNOUNCER',
  VIEWER = 'VIEWER'
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  user: User;
  token?: string;
  expiresAt?: Date | string;
}

/**
 * Permission constants for route guards
 */
export const Permissions = {
  // Setup permissions (admin only)
  EVENT_SETUP: 'event.setup',
  DIVISION_SETUP: 'division.setup',
  WEIGHT_SETUP: 'weight.setup',
  BRACKET_SETUP: 'bracket.setup',
  MAT_SETUP: 'mat.setup',

  // Data management
  MANAGE_WRESTLERS: 'wrestlers.manage',
  MANAGE_TEAMS: 'teams.manage',
  MANAGE_USERS: 'users.manage',

  // Operational
  CONTROL_BOUTS: 'bouts.control',
  SCORE_BOUTS: 'bouts.score',
  VIEW_QUEUES: 'queues.view',
  MANAGE_QUEUES: 'queues.manage',

  // Chat
  CHAT_VIEW: 'chat.view',
  CHAT_SEND: 'chat.send',

  // Reports
  VIEW_REPORTS: 'reports.view',
  EXPORT_REPORTS: 'reports.export',

  // Announcer
  ANNOUNCER_ACCESS: 'announcer.access'
} as const;
